export async function fetchWithToken(url, options = {}) {
  const token = sessionStorage.getItem("REACT_APP_TOKEN");

  const defaultHeaders = {
    Authorization: `Bearer ${token}`,
    "Content-Type": "application/json",
  };

  const finalOptions = {
    ...options,
    headers: {
      ...defaultHeaders,
      ...(options.headers || {}),
    },
  };

  return fetch(url, finalOptions);
}
